import { render, staticRenderFns } from "./IndividuellesPage.vue?vue&type=template&id=5407ebe8&scoped=true&"
import script from "./IndividuellesPage.vue?vue&type=script&lang=js&"
export * from "./IndividuellesPage.vue?vue&type=script&lang=js&"
import style0 from "./IndividuellesPage.vue?vue&type=style&index=0&id=5407ebe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5407ebe8",
  null
  
)

export default component.exports